import React from "react";

import { MetaTags } from "react-meta-tags";
import {
  Breadcrumbs,
  DashBreadcrumb,
} from "../../../components/Common/Breadcrumb";
//../../../components/Common/Breadcrumb
import {
    Col,
    Container,
    Row,
    FormGroup, 
    InputGroup, 
  } from "reactstrap";

import ImportFile from "./components/ImportFile/ImportFile.component"
const DeliveryReportUpload = () => {
  const isSprintxImport = window.location.pathname.toLowerCase().includes('import-sprintx-courier');
  const isMarketplaceStockImport = window.location.pathname
    .toLowerCase()
    .includes('import-marketplace-stock-file');
  const title = "Delivery Report";
  const description = "Delivery Report";

  const pageTitle = isMarketplaceStockImport
    ? 'Import Marketplace Stock File'
    : isSprintxImport
    ? 'Import Sprintx Courier Order'
    : 'Import Delivery Report';

  const breadcrumbTitle = isMarketplaceStockImport
    ? 'Marketplace Stock'
    : isSprintxImport
    ? 'Sprintx Courier'
    : 'Delivery Report';

  const breadcrumbItem = isMarketplaceStockImport
    ? 'Import Marketplace Stock File'
    : isSprintxImport
    ? 'Import Sprintx Courier Order'
    : 'Manage Delivery Report';

  const cardTitle = isMarketplaceStockImport
    ? 'Upload Marketplace Stock File'
    : isSprintxImport
    ? ''
    : 'Upload Delivery Report';

  const successMessageText = isMarketplaceStockImport
    ? 'Marketplace stock file upload will be reflected after some time'
    : isSprintxImport
    ? 'Sprintx courier status updation will be reflected after some time'
    : 'Delivery status updation will be reflected after some time';

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{pageTitle}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb
                title={breadcrumbTitle}
                breadcrumbItem={breadcrumbItem}
              />
            </Col>
          </Row>
         <ImportFile
          cardTitle={cardTitle}
            successMessageText={successMessageText}
          isSprintxImport={isSprintxImport}
          isMarketplaceStockImport={isMarketplaceStockImport}
          ></ImportFile>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default DeliveryReportUpload;
